// slider.js

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all slider components on the page
  initSliders();
  
  function initSliders() {
    const sliders = document.querySelectorAll('slider-component');
    
    sliders.forEach(slider => {
      const slides = slider.querySelectorAll('.staff-detail__slide');
      const thumbnails = slider.querySelectorAll('.staff-detail__thumbnail-btn');
      const prevButton = slider.querySelector('.staff-detail__slider-button--prev');
      const nextButton = slider.querySelector('.staff-detail__slider-button--next');
      
      if (!slides.length) return;
      
      let currentIndex = 0;
      const slideCount = slides.length;
      
      // Initialize: show first slide
      showSlide(currentIndex);
      
      // Set up thumbnail navigation
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          goToSlide(index);
        });
      });
      
      // Set up arrow navigation
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          goToSlide((currentIndex - 1 + slideCount) % slideCount);
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          goToSlide((currentIndex + 1) % slideCount);
        });
      }
      
      // Set up keyboard navigation
      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goToSlide((currentIndex - 1 + slideCount) % slideCount);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goToSlide((currentIndex + 1) % slideCount);
        }
      });
      
      // Touch swipe functionality
      let touchStartX = 0;
      let touchEndX = 0;
      
      slider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      slider.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        if (touchEndX < touchStartX - swipeThreshold) {
          // Swipe left: next slide
          goToSlide((currentIndex + 1) % slideCount);
        } else if (touchEndX > touchStartX + swipeThreshold) {
          // Swipe right: previous slide
          goToSlide((currentIndex - 1 + slideCount) % slideCount);
        }
      }
      
      function goToSlide(index) {
        // Don't do anything if already on this slide
        if (index === currentIndex) return;
        
        currentIndex = index;
        showSlide(currentIndex);
      }
      
      function showSlide(index) {
        // Hide all slides
        slides.forEach(slide => {
          slide.classList.remove('active');
          slide.style.display = 'none';
        });
        
        // Show the current slide
        slides[index].classList.add('active');
        slides[index].style.display = 'block';
        
        // Update thumbnail active states
        thumbnails.forEach((thumb, i) => {
          if (i === index) {
            thumb.classList.add('active');
            thumb.setAttribute('aria-current', 'true');
            
            // Scroll thumbnail into view if needed
            scrollThumbnailIntoView(thumb);
          } else {
            thumb.classList.remove('active');
            thumb.removeAttribute('aria-current');
          }
        });
      }
      
      function scrollThumbnailIntoView(thumbnail) {
        const container = slider.querySelector('.staff-detail__thumbnails-wrapper');
        if (!container) return;
        
        const scrollLeft = thumbnail.offsetLeft - (container.clientWidth / 2) + (thumbnail.clientWidth / 2);
        container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }
});